module.exports = __webpack_public_path__ + "img/refresh-icon.439192ca.svg";